import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { PARTIES_FIELDS, PARTIES_FORM_ARRAY_NAME } from './utils/constant';

export const generateValidationSchema = () => {
	return yupResolver(
		Yup.object().shape({
			[PARTIES_FORM_ARRAY_NAME]: Yup.object().shape({
				[PARTIES_FIELDS.FIRST_NAME]: Yup.string().required('First name is required'),
				[PARTIES_FIELDS.LAST_NAME]: Yup.string().required('Last name is required'),
				[PARTIES_FIELDS.COMPANY]: Yup.mixed().required('Company is required'),
				[PARTIES_FIELDS.CURRENCY]: Yup.array().required('Currency is required'),
				[PARTIES_FIELDS.ADDRESS]: Yup.array()
					.required('Please add atleast one address')
					.min(1, 'Please add atleast one address'),
				[PARTIES_FIELDS.CONTACTS]: Yup.array()
					.required('Please add atleast one Contact')
					.min(1, 'Please add atleast one Contact')
			})
		})
	);
};

export const generateValidationSchema1 = () => {
	return yupResolver(
		Yup.object().shape({
			[PARTIES_FORM_ARRAY_NAME]: Yup.object().shape({
				[PARTIES_FIELDS.TYPE]: Yup.string().required('Customer type is required'),

				[PARTIES_FIELDS.FIRST_NAME]: Yup.string().when('account_type', {
					is: (val: any) => val === 'Individual',
					then: () => Yup.string().required('First name is required'),
					otherwise: () => Yup.string().optional().nullable()
				}),

				[PARTIES_FIELDS.LAST_NAME]: Yup.string().when('account_type', {
					is: (val: any) => val === 'Individual',
					then: () => Yup.string().required('Last name is required'),
					otherwise: () => Yup.string().optional().nullable()
				}),

				[PARTIES_FIELDS.COMPANY_NAME]: Yup.string().when('account_type', {
					is: (val: any) => val === 'Company',
					then: () => Yup.string().required('Company is required'),
					otherwise: () => Yup.string().optional().nullable()
				}),

				[PARTIES_FIELDS.VAT_NUMBER]: Yup.string().optional().nullable()
					.max(15, 'VAT number should not exceed 15 digits')
					.matches(/^\d{15}$/, { excludeEmptyString: true, message: 'VAT number should have exactly 15 digits' }),

				[PARTIES_FIELDS.CRN]: Yup.string().optional().nullable()
					.max(10, 'CRN should not exceed 10 digits')
					.matches(/^\d{10}$/, { excludeEmptyString: true, message: 'CRN should have exactly 10 digits' }),

			[PARTIES_FIELDS.COMPANY]: Yup.mixed().required('Company is required'),

			[PARTIES_FIELDS.CURRENCY]: Yup.array().required('Currency is required'),
				[PARTIES_FIELDS.RESPONSIBLE_PERSON]: Yup.string().required('Responsible Person is required'),

				[PARTIES_FIELDS.ADDRESS]: Yup.array().nullable().notRequired(),

				[PARTIES_FIELDS.CONTACTS]: Yup.array()
					.required('Please add atleast one Contact')
					.min(1, 'Please add atleast one Contact'),

				[PARTIES_FIELDS.RECEIVABLE_ACCOUNT]: Yup.number().required('Receivable account is required'),
				[PARTIES_FIELDS.TAX_TEMPLATE]: Yup.number().required('Tax template is required')
			})

		})
	);
}
